import { type RegisterOptions } from 'react-hook-form';
import { type GeneralSettingsForm } from './generalSettingsFormTypes';

const isCancellationPolicyEnabled = (formValues: GeneralSettingsForm) =>
  formValues.cancellationPolicyEnabled === 1;

/** Used when cancellation policy controls are visible (`cancellationPolicyEnabled === 1`). */
export const cancellationFeeFieldRules: RegisterOptions<
  GeneralSettingsForm,
  'cancellationFee'
> = {
  validate: (value, formValues) => {
    if (!isCancellationPolicyEnabled(formValues)) {
      return true;
    }
    const raw = value as unknown;
    const n = Number(raw);
    if (raw === '' || raw == null || Number.isNaN(n)) {
      return 'Enter a valid cancellation fee';
    }
    if (n < 1) {
      return 'Fee must be at least $1';
    }
    if (n > 1000) {
      return 'Fee cannot exceed $1,000';
    }
    return true;
  },
};

/** Used when cancellation policy controls are visible (`cancellationPolicyEnabled === 1`). */
export const cancellationThresholdFieldRules: RegisterOptions<
  GeneralSettingsForm,
  'cancellationThreshold'
> = {
  validate: (value, formValues) => {
    if (!isCancellationPolicyEnabled(formValues)) {
      return true;
    }
    const trimmed = String(value ?? '').trim();
    if (trimmed === '') {
      return 'Enter a price threshold';
    }
    const n = Number.parseInt(trimmed, 10);
    if (Number.isNaN(n) || n < 0 || n > 10_000) {
      return 'Enter a valid price threshold';
    }
    return true;
  },
};
